import React, { useEffect } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import './PartLabelPrint.css'; // We'll style it next
import { useSelector } from 'react-redux';
import { RootState } from "../../redux/slices/store";

const PartLabelPrint: React.FC<any> = ({ data }) => {
  const companyDetails = useSelector((state:RootState) => state.companyProfile.companyDetails)
  const company = companyDetails?.[0];
  console.log("dsfa", company.logoUrl);

  useEffect(() => {
    console.log(companyDetails);
    console.log(company);
  },[])

  return (
    <div className="label-box">
      <div className="label-wrapper">
        <div className="label-header">
        <img src={`${company.logoUrl}`} alt='Logo' width={50} height={50} className='label-logo'/>
          <h3 className='label-title'>{company.companyName}</h3>
        </div>

        <div className="label-content">
          <div className="label-left">
            <div className="label-row"><strong>PART NO</strong> <p><strong>: {data.partNo}</strong></p></div>
            <div className="label-row"><strong>PART NAME</strong> <p><strong>: {data.partName}</strong></p></div>
            <div className="label-row"><strong>MODEL</strong> <p><strong>: {data.model}</strong></p></div>
            <div className="label-row"><strong>BATCH NO</strong> <p><strong>: {data.batchNo}</strong></p></div>
            <div className="label-row"><strong>INV/DC NO</strong> <p><strong>: {data.invNo}</strong></p></div>
            <div className="label-row"><strong>GRN NO</strong> <p><strong>: {data.grnNo}</strong></p></div>
            <div className="label-row"><strong>SUPPLIER</strong> <p><strong>: {data.supplier}</strong></p></div>
            <div className="label-row"><strong>BARCODE</strong> <p><strong>: {data.barcode}</strong></p></div>
            <div className="label-row"><strong>RECEIVED DT</strong> <p><strong>: {data.receivedDate}</strong></p></div>
          </div>

          <div className="label-right">
            <p><strong>CATEGORY : {data.category}</strong></p>
            <p><strong>RACK : {data.rack}</strong></p>
            <p><strong>QTY : {data.qty} Pcs</strong></p>
            <div className="qr-code">
              <QRCodeCanvas value={data.barcode} size={75} />
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default PartLabelPrint;
